import React, { useState } from 'react';
import { Container, Tab, Tabs } from 'react-bootstrap';
import ManagerAccessPage from './ManagerAccessPage';
import EmployeeRolesPage from './EmployeeRolesPage';

const AccessPage = ({ jwt }) => {
    const [activeTab, setActiveTab] = useState('roles');

    return (
        <Container style={{ maxWidth: '1440px', margin: '40px auto' }}>
            <h1 style={{ textAlign: 'center' }}>Доступы</h1>
            <Tabs
                activeKey={activeTab}
                onSelect={(key) => setActiveTab(key)}
                className="mb-3"
            >
                <Tab eventKey="roles" title="Роли сотрудников">
                    <EmployeeRolesPage jwt={jwt} />
                </Tab>
                <Tab eventKey="managers" title="Доступы менеджеров">
                    <ManagerAccessPage jwt={jwt} />
                </Tab>
            </Tabs>
        </Container>
    );
};

export default AccessPage;
